module.exports = __webpack_public_path__ + "static/media/24UHCHR18.da2d18bc.jpg";